// extracted by mini-css-extract-plugin
module.exports =  {"button":"nSIXLuzHniArX8zLDfha"};